import React from 'react';
import QuestionnaireValueRadio from "./questionnaire_value_radio";

export default function QuestionnaireValureRadioFloat(props){

  return (
    <QuestionnaireValueRadio {...props} />
  )

}